import * as GtmConstants from '../constants';
import * as D from '../deps';

import * as GtmWorkers from './workers';

export default [
  {
    actionType: GtmConstants.Actions.SIGN_UP_CLICKED,
    handler: GtmWorkers.onSignUpClick,
    concur: 'takeEvery',
  },
  {
    actionType: GtmConstants.Actions.APP_STORE_LINK_CLICKED,
    handler: GtmWorkers.onAppStoreCtaClick,
    concur: 'takeEvery',
  },
  {
    actionType: GtmConstants.Actions.VIEW_PLANS_CLICKED,
    handler: GtmWorkers.onViewPlansClick,
    concur: 'takeEvery',
  },
  {
    actionType: GtmConstants.Actions.UPGRADE_CTA_CLICKED,
    handler: GtmWorkers.onUpgradeCTAClick,
    concur: 'takeLatest',
  },
  {
    actionType: GtmConstants.Actions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
    handler: GtmWorkers.onUpgradeDiscountPlanLinkClicked,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Payments.Actions.ACQUIRE_OFFER_SUCCESS,
    handler: GtmWorkers.onAcquireOfferSuccess,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Payments.Actions.LISTENER_AND_SUBSCRIPTION_READY,
    handler: GtmWorkers.onListenerAndSubscriptionReady,
    concur: 'takeLatest',
  },
];
